// Syte Recommendations Markup
// https://guidelines.syte.ai/5c8a9b7e5/p/784372-getting-started-with-rec-engines/b/227a80  pw: aipower001
import React from 'react';
import withStyles from '@tcp/core/src/components/common/hoc/withStyles';
import styles from './styles/Recommendations.style';

const SyteRecommendations = ({ className, config, children, ...props }) => {
  const dataSku = { [config.multiSkus ? `data-skus` : 'data-sku']: config.sku };

  config?.trackClick({
    customEvents: [
      `event: trackLinkEvent`,
      `eventCategory : pdp interactions`,
      `eventAction: shop similar:rec`,
      `eventLabel: shop similar:impression`,
    ],
  });

  return (
    <div
      className={`${className} syte-recommendations`}
      id={config.id}
      data-image-src={config.image}
      data-placement={config.placement}
      tabIndex="0"
      onClick={(e) => {
        const imgAlt = e.target.getAttribute('alt')
          ? e.target.getAttribute('alt')
          : e.target.getAttribute('aria-label');
        config?.trackClick({
          customEvents: [
            'event101',
            `clicked element: ${imgAlt}`,
            `Syte ID: ${config.id}`,
            `Syte Placement: ${config.placement}`,
            `Product Image: ${config.image}`,
            `Product SKU: ${config.sku}`,
            `event: trackLinkEvent`,
            `eventCategory: pdp interactions`,
            `eventAction: shop similar:rec`,
            `eventLabel: shop similar:clicks`,
          ],
          syte_shop_similar_metrics102: 'syte recommendations click - shop similar',
          dimension101: 'shop similar',
        });
      }}
      onKeyDown={() => {}}
      {...dataSku}
      {...props}
      role="menu"
    />
  );
};

export default React.memo(withStyles(SyteRecommendations, styles));
